// @flow

import React from 'react';

import CouldNotVerify from '../../../../components/Icons/SelfEnrollment/CouldNotVerify';
import EnrollmentFailed from '../../../../components/Icons/SelfEnrollment/EnrollmentFailed';
import { SCENARIOS } from '../../constants';

import styles from './styles.module.scss';

type Props = {
  scenario: string,
};

const renderImage = (scenario: string) => {
  if (scenario === SCENARIOS.ENROLLMENT_FAILED) {
    return <EnrollmentFailed />;
  }

  return <CouldNotVerify />;
};

const Image = ({ scenario }: Props) => <div className={styles.image}>{renderImage(scenario)}</div>;

export default Image;
